import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {LinkButtonNew} from '@components/common/base/buttons'
import {stickerCtl} from '@extensions/sticker/sticker'
import {useStickerEditorStore} from '../sticker-editor-store'
import {SprintStateEdit} from './sprint-state-edit/sprint-state-edit'
import {SprintStateItem} from './sprint-state-item/sprint-state-item'

const sprintCtl = stickerCtl.Sprint

export const SprintStates = observer(() => {
  const [state, store] = useStickerEditorStore()

  useEffect(() => {
    state.sticker && store.setSprintStates(sprintCtl.listStates(state.sticker))
  }, [state.sprintState, state.sticker])

  return (
    <div className="flex flex-col gap-8 py-8">
      <div className="text-sm-semibold">{Lang.msg.myStickers.states}</div>
      {state.stickerEdited ? (
        <SprintStateEdit />
      ) : (
        <LinkButtonNew
          icon="IconPlus"
          title={Lang.msg.myStickers.AddInterval}
          onClick={store.addSprintState}
          className="ml-4"
        />
      )}
      {state.sticker &&
        state.sprintStates.map(state => (
          <SprintStateItem sprintStickerState={state} key={state.id} />
        ))}
    </div>
  )
})
